<div class="input flex items-center relative">
    @if (getValue() !== Colors.NONE) {
        <app-color-detail [color]="getValue()" />
    } @else {
        <label>-</label>
    }
    @if (!customColorMode) {
        <select class="absolute left-20 w-[70%] border-0 bg-transparent" [formGroup]="formGroup!" [attr.formControlName]="formControlName" (change)="changeColor($event)">
            @for (item of values; track $index) {
                <option [value]="item" [selected]="getValue() === item">{{ getColorLabel(item) }}</option>
            }
            <option value="CUSTOM" [selected]="isCustomValue()">{{ isCustomValue() ? customColorValue : getColorLabel('custom') }}</option>
        </select>
    } @else {
        <div class="absolute left-20 w-[70%] flex items-center gap-1">
            <input type="text"
                   #customColorInput
                   class="border border-gray-300 rounded px-2 py-1 flex-1"
                   [value]="customColorValue"
                   [attr.maxlength]="APP.HEX_COLOR_MAX_LENGTH"
                   (input)="changeCustomColor($event)"
                   placeholder="#000000" />
            <button type="button" class="w-5 h-5 flex items-center justify-center text-gray-500 hover:text-gray-700 cursor-pointer" (click)="customColorMode = false">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
            </button>
        </div>
    }
</div>